
import DatePicker from './datePicker'
import TimePicker from './timePicker'
export default {
  name: 'MZDateTimePicker',
  props: {
    ...TimePicker.props,
    ...DatePicker.props
  },
  components: {
    DatePicker,
    TimePicker
  },
  mounted () {
        // this.$refs.timePicker.setAttribute({})
        // console.log('child',this.$children)
        // this.render()
  },
  render (createElement) {
        // const Component = this.type === 'time' ? TimePicker : DatePicker;
    if (this.type === 'time') {
      return createElement('TimePicker', {
        ref: 'root',
        class: 'mz-datetime-picker',
        ...{
          props: this.$props,
          on: this.$listeners
        }
      })
    } else {
      return createElement('DatePicker', {
        ref: 'root',
        class: 'mz-datetime-picker',
        ...{
          props: this.$props,
          on: this.$listeners
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/_mengzhua-ui@1.1.4@mengzhua-ui/components/dateTimePicker/index.vue